export default __webpack_public_path__ + "assets/images/da23f5948723544d687a3c00b34e59fc.png";